import React from 'react';
import { Input } from './ui/input';
import { Package2 } from 'lucide-react';

export const PESO_MAX_G = 30000;
const ATALHOS = [300, 500, 1000, 2000, 5000, 10000, 20000, 30000];

export const rotuloPeso = (g) => (g >= 1000 ? `${String(g / 1000).replace('.', ',')} kg` : `${g} g`);

export const pesoParaGramas = (v) => {
  const n = parseInt(String(v ?? '').replace(/\D/g, ''), 10);
  return Number.isNaN(n) ? 0 : Math.min(n, PESO_MAX_G);
};

const PesoInput = ({ value, onChange, id = 'peso' }) => {
  const g = pesoParaGramas(value);

  return (
    <div>
      <div className="relative mt-1.5">
        <Package2 className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          id={id} inputMode="numeric" value={value}
          onChange={(e) => {
            const d = e.target.value.replace(/\D/g, '').slice(0, 5);
            onChange(d === '' ? '' : String(Math.min(parseInt(d, 10), PESO_MAX_G)));
          }}
          placeholder="Ex.: 300" className="pl-9 pr-24 h-11 bg-slate-50 border-slate-200"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-500">
          gramas{g >= 1000 ? ` (${rotuloPeso(g)})` : ''}
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {ATALHOS.map((a) => (
          <button
            key={a} type="button" onClick={() => onChange(String(a))}
            className={`px-2.5 py-1 rounded-full text-xs font-semibold border transition-colors ${g === a ? 'bg-[#2A5BC7] text-white border-[#2A5BC7]' : 'border-slate-200 text-slate-600 hover:border-[#2A5BC7] hover:text-[#2A5BC7]'}`}
          >
            {rotuloPeso(a)}
          </button>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-1.5">Peso máximo dos Correios: 30 kg (30.000 g).</p>
    </div>
  );
};

export default PesoInput;
